// Components/PDF/Styles/SummaryStyles.js
import { StyleSheet } from "@react-pdf/renderer";
import theme from "../../../../../../css/Theme/Theme";

const BORDER = theme.colors.Grey25;
const HEADER_BG = theme.colors.GhostWhite;
const BRAND = theme.colors.Brand1PenBlue;

const pdfStyles = StyleSheet.create({
  wrapper: {
    marginTop: 16,
    paddingBottom: 40, // space above footer
    position: "relative",
    minHeight: "100%", // ensures footer sits at page bottom
  },

  totalsText: {
    fontFamily: "Open Sans",
    fontSize: 12,
    color: BRAND,
    fontWeight: "bold",
    marginTop: 6,
    lineHeight: 1.5,
  },

  table: {
    width: "30%",
    borderTopWidth: 1,
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderColor: BORDER,
    borderStyle: "solid",
    fontFamily: "Open Sans",
    color: BRAND,
  },

  headerRow: {
    flexDirection: "row",
    backgroundColor: HEADER_BG,
    borderBottomWidth: 1,
    borderBottomColor: BORDER,
    borderStyle: "solid",
    paddingTop: 6,
    paddingBottom: 6,
    marginTop: 0,
  },
  headerLabel: {
    width: "70%",
    paddingLeft: 4,
    fontSize: 12,
    fontWeight: "bold",
  },
  headerCount: {
    width: "30%",
    textAlign: "right",
    paddingRight: 4,
    fontSize: 12,
    fontWeight: "bold",
  },

  row: {
    flexDirection: "row",
    paddingVertical: 4,
    borderBottomWidth: 1,
    borderBottomColor: BORDER,
    borderStyle: "solid",
  },
  cellLabel: {
    width: "70%",
    paddingLeft: 4,
    fontSize: 12,
  },
  cellCount: {
    width: "30%",
    textAlign: "right",
    paddingRight: 4,
    fontSize: 12,
  },

  totalRow: {
    flexDirection: "row",
    paddingVertical: 4,
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderColor: BORDER,
    borderStyle: "solid",
    backgroundColor: "#fafafa",
  },
  totalLabel: {
    width: "70%",
    paddingLeft: 4,
    fontSize: 12,
    fontWeight: "bold",
  },
  totalCount: {
    width: "30%",
    textAlign: "right",
    paddingRight: 4,
    fontSize: 12,
    fontWeight: "bold",
  },

  footer: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    textAlign: "center",
    fontFamily: "Open Sans",
    fontSize: 12,
    color: BRAND,
    lineHeight: 1.5,
    paddingTop: 6,
    marginTop: 16,
  },
});

export default pdfStyles;
